import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { SearchObject } from 'src/app/services/Rest';
import { Order, Sat_Factura, Billing_Data } from 'src/app/models/RestModels';
import { ParamMap } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';
import { forkJoin, of } from 'rxjs';
import {Utils} from 'src/app/classes/Utils';
import { ExcelUtils } from 'src/app/classes/ExcelUtils';
import { OrderInfo, PaymentInfo } from 'src/app/models/models';

export interface CSatFacturaInfo extends Sat_Factura
{
	name_type:string;
	sat_cancelled:string;
	link: Array<any>;
	system_status: string;
	client_name?: string;
	total?: number;
	order: Order | null;
	payment_info: PaymentInfo | null;
}

@Component({
	selector: 'app-list-sat-factura',
	templateUrl: './list-sat-factura.component.html',
	styleUrls: ['./list-sat-factura.component.css']
})
export class ListSatFacturaComponent extends BaseComponent implements OnInit
{

	sat_factura_search: SearchObject<Sat_Factura> = this.getEmptySearch();
	sat_factura_info_list: CSatFacturaInfo[] = [];
	billing_data_list: Billing_Data[] = [];

	reenviar_factura_name:string = '';
	reenviar_factura_email:string = '';
	show_reenviar_factura:boolean = false;

	modal_response: string = '';
	modal_UUID: string = '';
	modal_factura_id: number | '';
	show_checar_factura: boolean = false;

	endx: string = '';
	startx: string = '';
	billing_data_id: string = '';

	ngOnInit(): void
	{
		this.path = '/list-sat-factura';

		this.subs.sink = this.route.queryParamMap.pipe
		(
			mergeMap((param_map: ParamMap) =>
			{
				this.setTitle('Reporte de facturas');
				this.is_loading = true;
				this.sat_factura_search.limit = this.page_size;
				this.sat_factura_search = this.getSearch(param_map, ['created','type','order_id','payment_id','serie','folio'], ['billing_data_id','status_filter','monto']);

				this.startx = '';
				this.endx = '';

				if(this.sat_factura_search.ge.created)
				{
					this.startx = Utils.getLocalMysqlStringFromDate(this.sat_factura_search.ge.created as Date);
				}

				if(this.sat_factura_search.le.created)
				{
					this.endx = Utils.getLocalMysqlStringFromDate(this.sat_factura_search.le.created as Date);
				}

				if (this.sat_factura_search.sort_order.length == 0)
				{
					this.sat_factura_search.sort_order = ['id_DESC'];
				}

				this.current_page = this.sat_factura_search.page;

				let status_filter = this.sat_factura_search.search_extra.status_filter;

				if (status_filter === 'active')
				{
					this.sat_factura_search.is_null = ['system_cancelled_timestamp'];
					this.sat_factura_search.nn = ['uuid'];
					this.sat_factura_search.eq.cancelado_por_sat = 'NO';
				}
				else if (status_filter === 'cancelled_sat')
				{
					this.sat_factura_search.eq.cancelado_por_sat = 'YES';
				}
				else if (status_filter === 'cancelled_system')
				{
					this.sat_factura_search.nn = ['system_cancelled_timestamp'];
				}

				return this.rest.sat_factura.search(this.sat_factura_search);
			}),
			mergeMap
			(
				(response) =>
				{
					let payment_ids = response.data.map(f => f.payment_id).filter(id => id);

					let payment_obs = payment_ids.length > 0
						? this.rest.payment_info.search({ csv: { id: payment_ids }, limit: payment_ids.length })
						: of({ total: 0, data: [] });

					return forkJoin
					({
						sat_factura: of(response),
						payments: payment_obs
					})
				}
			),
			mergeMap
			(
				(response) =>
				{
					let order_ids = response.sat_factura.data.map(f => f.order_id).filter(id => id);
					let payment_order_ids = response.payments.data.map((p: PaymentInfo) => p.movements?.[0]?.bank_movement_orders?.[0]?.order_id).filter(id => id);

					order_ids.push(...payment_order_ids);

					console.log('Order IDs:', order_ids);

					let order_obs = order_ids.length > 0
						? this.rest.order.search({ csv: { id: order_ids }, limit: order_ids.length })
						: of({ total: 0, data: [] });

					return forkJoin
					({
						sat_factura: of(response.sat_factura),
						payments: of(response.payments),
						orders: order_obs,
						billing_data: this.rest.billing_data.search({limit: 9999})
					});
				}
			)
    	)
		.subscribe((response) =>
		{
			this.billing_data_list = response.billing_data.data;
			this.sat_factura_info_list = response.sat_factura.data.map((i) => this.getType(i, response.orders.data, response.payments.data));
			this.setPages(this.sat_factura_search.page, response.sat_factura.total);
			this.is_loading = false;
		});
  	}

	getType(sat_factura: Sat_Factura, order_list: Order[], payment_info_list: PaymentInfo[]): CSatFacturaInfo {
		let link: (string | number)[] = [];

		if (sat_factura.type == 'NORMAL')
			link = ['/view-order', sat_factura.order_id];

		if (sat_factura.type == 'COMPLEMENTO_PAGO')
			link = ['/view-payment', sat_factura.payment_id];

		let name_type = 'Desconocido';

		if (sat_factura.type == 'POR_PERIODO')
		{
			name_type = 'Factura por periodo';
		}

		if (sat_factura.type == 'NORMAL')
		{
			name_type = 'Facturación';
		}

		if (sat_factura.type == 'COMPLEMENTO_PAGO')
		{
			name_type = 'Factura de pago';
		}

		let sat_cancelled = sat_factura.cancelado_por_sat == 'NO' ? 'Activo' : 'Cancelado';
		let system_status = sat_factura.system_cancelled_timestamp == null ? 'Activo' : 'Cancelado';

		let payment_info: PaymentInfo | null = payment_info_list.find(p => p.payment.id == sat_factura.payment_id) || null;

		let order: Order | null = order_list.find(o => o.id == sat_factura.order_id
			|| (payment_info && payment_info.movements?.[0]?.bank_movement_orders?.[0]?.order_id == o.id)) || null;

		let client_name = order?.client_name || '';

		//let folio = order?.store_consecutive;
		let total = sat_factura.type == 'POR_PERIODO' ? 0
		: ((order?.total || 0) - (order?.discount || 0)) || (payment_info?.payment.payment_amount || 0);

		return {
			...sat_factura, name_type, sat_cancelled, link, system_status, client_name, total, payment_info, order
		};
	}

	getPdfUrl(sat_factura: Sat_Factura)
	{
		return this.rest.getApiUrl()+'/getFacturaPdf.php?sat_factura_id='+sat_factura.id;
	}

	checarFactura(sat_factura: CSatFacturaInfo)
	{
		this.is_loading = true;
		this.modal_UUID = sat_factura.uuid;
		this.modal_factura_id = sat_factura.id;
		let auth_header = this.rest.getSessionHeaders().get('Authorization') || '';

		fetch(this.rest.getApiUrl()+'/checar_factura.php?sat_factura_id='+sat_factura.id,
		{headers: {Authorization: auth_header}} )
		.then(response => response.json())
		.then(data =>
		{
			console.log(data);

			if (data.estado)
			{
				this.is_loading = false;
				this.modal_response = data.estado;


				this.show_checar_factura = true;
			}
			else
			{
				this.showError('Error al revisar el estado de la factura');
			}

		})
		.catch(error =>
		{
			console.error('Error:', error);
		});
	}

	resendFactura(evt:Event)
	{
		// console.log("HOLA SI JALO LA FUNCIÓN");
	}

	replayFactura(sat_factura:Sat_Factura)
	{
		this.is_loading = true;

		this.sink = this.rest.replayFactura( sat_factura.id )
		.subscribe((sat_factura2)=>
		{
			//sat_factura = this.getType(sat_factura);
			sat_factura.uuid = sat_factura2.uuid;

		},(error)=>this.showError(error));
	}

	cancelarFactura(sat_factura:Sat_Factura)
	{
		this.subs.sink = this.confirmation
		.showConfirmAlert
		(
			sat_factura,
			'Cancelar Factura',
			'¿Estas seguro de cancelar esta factura?'
		)
		.pipe
		(
			filter(result=>result.accepted),
			mergeMap((result)=>
			{
				this.is_loading = true;
				let sat_factura = result.obj as Sat_Factura;
				return this.rest.cancelar_factura.create({ sat_factura_id: sat_factura.id });
			}),
		)
		.subscribe
		({
			next:(_response)=>this.showSuccess('La factura se cancelo correctamente'),
			error:(error)=>this.showError(error)
		});
	}

	searchReport()
	{
		this.search( this.sat_factura_search );
		console.log( "ESTE ES EL SARCH REPORT: ", this.sat_factura_search );
	}

	export()
	{
		this.is_loading = true;

		this.rest.sat_factura.searchAll(this.sat_factura_search)
		.pipe
		(
			mergeMap((response) =>
			{
				let payment_ids = response.data.map(f => f.payment_id).filter(id => id);

				let payment_obs = payment_ids.length > 0
					? this.rest.payment_info.search({ csv: { id: payment_ids }, limit: payment_ids.length })
					: of({ total: 0, data: [] });

				return forkJoin
					({
						sat_factura: of(response),
						payments: payment_obs
					})
			}),
			mergeMap((response) =>
			{
				let order_ids = response.sat_factura.data.map(f => f.order_id).filter(id => id);
				let payment_order_ids = response.payments.data.map((p: PaymentInfo) => p.movements?.[0]?.bank_movement_orders?.[0]?.order_id).filter(id => id);

				order_ids.push(...payment_order_ids);

				let order_obs = order_ids.length > 0
					? this.rest.order.search({ csv: { id: order_ids }, limit: order_ids.length })
					: of({ total: 0, data: [] });

				return forkJoin
					({
						sat_factura: of(response.sat_factura),
						payments: of(response.payments),
						orders: order_obs
					});
			})
		)
		.subscribe
		({
			next: (response) =>
			{
				let facturas = response.sat_factura.data.map((i) => this.getType(i, response.orders.data, response.payments.data));
					let facturas_validas = facturas.filter(f => f.uuid);

				let rows = facturas_validas.map(f =>
				({
					'ID': f.id,
					'Folio': f.folio || '',
					'Tipo': f.name_type,
					'Cliente': f.client_name || '',
					'Monto Total': f.total,
					'UUID': f.uuid,
					'Fecha': f.created,
					'Estatus': f.system_status,
					'Estatus CFDI': f.sat_cancelled,
				}));

				let headers = ['ID', 'Folio', 'Tipo', 'Cliente', 'Monto Total', 'UUID', 'Fecha', 'Estatus', 'Estatus CFDI'];
				ExcelUtils.array2xlsx(rows, 'Facturas.xlsx', headers);
				this.is_loading = false;
			},
			error: (error) =>
			{
				this.showError(error);
				this.is_loading = false;
			}
		});
	}

    print()
	{
        this.rest.hideMenu?.();
        setTimeout(() => window.print(), 500);
    }

}
